import React from 'react';
import SearchInput from '../search-Input';
import {tFilterObject, anyObject, tActiveFilters, tAppTempUnit} from '../../types/typedefinitons'
import ResultRows from './resultRows';
import { useTranslation } from 'react-i18next';

const StandardView:React.FC<{resultViewActive:boolean, setView:React.Dispatch<React.SetStateAction<string>>, dataForSearch:any, isLoadingContent:boolean, loadedContentLength:number, fuseOptions:{}, setSelectedValues:(action:string, changedValue?:tFilterObject) => void, columnDefs:anyObject[], dataToDisplay:anyObject, selectedValues:tActiveFilters, appTempUnit:tAppTempUnit}> = ({setView, dataForSearch, fuseOptions, selectedValues, setSelectedValues, dataToDisplay, columnDefs, appTempUnit,resultViewActive,isLoadingContent, loadedContentLength}) => {
    const { t, i18n } = useTranslation();
    return (
        <>
        <SearchInput 
            rawData = {dataForSearch}
            fuseOptions = {fuseOptions}
            setSelectedValues = {setSelectedValues}
            selectedValues = {selectedValues}
            disabled = {isLoadingContent}
        />
        {isLoadingContent ?  <p className="rs-loading-text" style={{marginBottom:'20px'}}>{t('info.loading.progress',{length:loadedContentLength})}</p> : null}
        {resultViewActive ?
            <ResultRows 
            dataToDisplay = {dataToDisplay}
            selectedValues = {selectedValues}
            columnDefs = {columnDefs}
            setSelectedValues = {setSelectedValues}
            appTempUnit = {appTempUnit}  
            />
        :
        <div>
            <p className="gemu-rs-search-hints-title">{t('searchTipps.title')}</p>
            <ul className="gemu-rs-search-hints">
                <li>{t('searchTipps.tip1')}</li>
                <li>{t('searchTipps.tip2')}</li>
            </ul>
        </div>
        }
        </>
    )
}

export default StandardView;

